import { IconButton } from 'src/components/atoms';
import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const TagTypeBodyStyled = styled.div`
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
export const DividerContainer = styled.div`
  padding: 0 20px;
`;

export const TagTypeBodyContainer = styled.div`
  padding: 30px 0px;
  align-self: stretch;
  justify-content: space-between;
`;

export const TagTypeBodyWrapper = styled.div<{
  dimmed?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
  ${(props) => props.dimmed && 'opacity: 0.5;'}
`;

export const TagTypeSwitchTitle = styled.p`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N1000
      : props.theme.atlas.semantic.color.type.default};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleHeading
      : textStyleCss(theme.atlas.typography.semantic.body)};
  margin: 0 0 8px -145px;
`;

export const TagTypeBodyTitle = styled.p`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N1000
      : props.theme.atlas.semantic.color.type.default};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleHeading
      : textStyleCss(theme.atlas.typography.semantic.body)};
  margin: 0 0 8px 10px;
`;

export const TagTypeBodySubTitle = styled.span`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.body)};
  font-style: italic;
  margin: 0;
`;

export const TagTypeContainerRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  margin-top: 10px;
`;

export const TagTypeButtonList = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  flex-direction: row;
`;

export const TagTypeIconButton = styled(IconButton)`
  &:disabled {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N0
        : props.theme.atlas.semantic.color.surface.default};
    border: none;
  }
`;

export const TagTypeContainerLeft = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-items: flex-start;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
`;

export const HelpTextWrapper = styled.div`
  display: flex;
  padding-left: 29px;
`;

export const StyledIconWrapper = styled.div`
  padding-right: 10px;
`;
